var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRatingLEmpty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.896 11.967c-.16 0-.398-.083-.558-.166-.318-.25-.477-.582-.398-.997l.478-3.075-2.15-2.16A1.303 1.303 0 01.03 4.487a.783.783 0 01.796-.665l2.945-.416L5.124.582C5.284.249 5.682 0 6 0c.398 0 .716.25.876.582l1.353 2.825 2.945.416c.398.083.637.332.796.665.08.332 0 .748-.239.997L9.582 7.729l.478 3.075c.08.415-.08.748-.398.997a.945.945 0 01-1.035.083L5.92 10.388l-2.706 1.496s-.16.083-.318.083zM6 9.225c.16 0 .318 0 .478.083l2.467 1.33-.477-2.826c-.08-.332.08-.665.238-.914l1.99-1.995-2.706-.415c-.318-.083-.557-.25-.716-.582L6.08 1.33 4.806 3.99c-.16.332-.398.498-.716.58l-2.707.416 1.99 1.995c.239.25.319.582.239.914l-.478 2.826 2.468-1.33c.08-.166.239-.166.398-.166z",
    fill: "#F2B718"
  })));
}
export default SvgRatingLEmpty;